import { SelectButton } from 'primereact/selectbutton';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateUser } from '../../store/actions/proyectAction';

const Activo = ({ t, updateUser, currentUser, toast }) => {
  const options = [t('Habilitar'), t('Deshabilitar')];
  const updateUsuarioActivo = async value => {
    const activo = value === t('Habilitar') ? true : false;
    try {
      await updateUser({ ...currentUser, activo });
      toast?.current?.show({
        severity: 'info',
        summary: t('Confirmed'),
        detail: t('Estado de usuario actualizado'),
        life: 3000,
      });
    } catch (e) {
      toast?.current?.show({
        severity: 'error',
        summary: t('Rejected'),
        detail: t('Estado de usuario no actualizado'),
        life: 3000,
      });
      throw new Error(e);
    }
  };
  return (
    <div className="p-col-12 p-md-12 floatLeft">
      <h3
        className="floatLeft"
        style={{ transform: 'translateY(-4px)', marginRight: '8px' }}
      >
        {' '}
        {t('Estado del Usuario')}:
      </h3>
      <SelectButton
        className="p-col-12"
        value={currentUser?.activo ? t('Habilitar') : t('Deshabilitar')}
        options={options}
        onChange={e => updateUsuarioActivo(e.value)}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateUser,
    },
    dispatch,
  );

export default connect(
  null,
  mapDispatchToProps,
)(withTranslation('translations')(Activo));
